// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3BGMn","col":"styles_col__35NB2"};